module.exports = __webpack_public_path__ + "static/home-bg-162a98851f366a3b8d38c0a4950fd74e.png";